import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { User } from '@supabase/supabase-js';
import { track, setAnalyticsUser, initClickTracking } from '../lib/analytics';

// Logs a page_view on every route change, a one-time `signup` for brand-new
// accounts, and turns on tap tracking for any element marked data-track.
export default function AnalyticsTracker({ user }: { user: User | null }) {
  const { pathname } = useLocation();

  useEffect(() => { initClickTracking(); }, []);
  useEffect(() => { setAnalyticsUser(user?.id ?? null); }, [user?.id]);

  useEffect(() => { track('page_view'); }, [pathname]);

  useEffect(() => {
    if (!user?.created_at) return;
    const key = `yhuu_signup_tracked_${user.id}`;
    const isNew = Date.now() - new Date(user.created_at).getTime() < 10 * 60 * 1000;
    try {
      if (isNew && !localStorage.getItem(key)) {
        localStorage.setItem(key, '1');
        track('signup');
      }
    } catch { /* ignore */ }
  }, [user?.id]);

  return null;
}
